<script setup lang="ts">
import { ref } from 'vue'
import { Head, Link } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Table from '@/Components/Table/Table.vue'
import { useFormatTime } from '@/Composables/useFormatTime'
import CreateDeliveryNote from '@/Components/Master/DeliveryNotes/CreateDeliveryNote.vue'
import PrintDeliveryNotesPDF from '@/Components/Master/DeliveryNotes/PrintDeliveryNotesPDF.vue'

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    data: {}
}>()

const selectedDeliveryNotes = ref<any[]>([])

const handleSelectRow = (selectRow: { [key: string]: boolean }) => {
    const allData = (props.data as any)?.data ?? []
    selectedDeliveryNotes.value = allData.filter((dn: any) => selectRow[dn.id] === true)
}
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead">
        <template #other>
            <PrintDeliveryNotesPDF :deliveryNotes="selectedDeliveryNotes" />
            <CreateDeliveryNote />
        </template>
    </PageHeading>

    <Table
        :resource="data"
        name="default"
        :isCheckBox="true"
        checkboxKey="id"
        @onSelectRow="handleSelectRow"
    >
        <template #cell(created_at)="{ item }">
            {{ useFormatTime(item.created_at) }}
        </template>

        <template #cell(reference)="{ item }">
            <Link :href="route('casheer.delivery_notes.show', item.slug)" class="primaryLink">
                {{ item.reference }}
            </Link>
        </template>

        <template #cell(delivery_date)="{ item }">
            {{ item.delivery_date ? useFormatTime(item.delivery_date) : '-' }}
        </template>

        <template #cell(recipient_name)="{ item }">
            <span v-tooltip="'Nama penerima'" class="font-bold">{{ item.recipient_name ?? '-' }}</span> <span v-tooltip="'Alamat penerima'" class="italic opacity-60">({{ item.recipient_address ?? '-' }})</span>
        </template>

        <template #cell(created_by_name)="{ item }">
            {{ item.created_by_name ?? '-' }}
        </template>
    </Table>
</template>
